<script lang="ts">
  import { goto } from '$app/navigation';
  import { page } from '$app/state';
  import { type Snippet } from 'svelte';

  import Button from '$shared/atoms/Button/Button.svelte';
  import { ButtonStyle } from '$shared/constants/ButtonStyle';
  import Label from '$provider/constants/Label';

  interface Props {
    name: string;
    okLabel?: string;
    cancelLabel?: string;
    loading?: boolean;
    disabled?: boolean;
    hideAction?: boolean;
    hasCustomAction?: boolean;
    hideCancel?: boolean;
    leftActions?: Snippet | undefined;
    feedbackAction?: Snippet | undefined;
    children?: Snippet | undefined;
    actions?: Snippet | undefined;
    oncancel?: () => void;
    onok?: () => void;
    onfeedback?: () => void;
  }

  let {
    name,
    okLabel = '',
    cancelLabel = '',
    loading = false,
    disabled = false,
    hideAction = false,
    hasCustomAction = false,
    hideCancel = false,
    leftActions = undefined,
    feedbackAction = undefined,
    children = undefined,
    actions = undefined,
    oncancel,
    onok,
    onfeedback
  }: Props = $props();

  const onClickCancel = (): void => {
    const lastLocation: string | null = page.url.searchParams.get('ll');
    if (lastLocation) {
      goto(lastLocation);
      return;
    }
    oncancel?.();
  };

  const onClickOk = (): void => {
    onok?.();
  };

  const onClickFeedback = (): void => {
    onfeedback?.();
  };
</script>

<div data-cy={`${name}-header`} class="header">
  <div class="cancel">
    {#if !hideCancel}
      <Button name={`${cancelLabel || Label.Cancel}-btn`} onclick={onClickCancel}>
        {cancelLabel || Label.Cancel}
      </Button>
      {@render leftActions?.()}
    {/if}
  </div>
  {@render children?.()}
  {#if !hideAction}
    <div class="actions">
      {@render actions?.()}
      {@render feedbackAction?.()}
      {#if !hasCustomAction}
        <Button
          disabled={loading || disabled}
          {loading}
          style={ButtonStyle.Primary}
          name={`${okLabel || Label.Submit}-btn`}
          onclick={onClickOk}
        >
          {okLabel || Label.Submit}
        </Button>
      {/if}
    </div>
  {/if}
</div>

<style>
  .header {
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    justify-content: space-between;
    height: 56px;
    padding: 0 24px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
  }
  .cancel,
  .actions {
    display: flex;
    align-items: center;
  }
  .actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
</style>
